"use client";

import React from "react";
import { Facebook, Instagram, Linkedin, Send, Twitter } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { FormProvider } from "@/integrations/forms/FormProvider";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i} className="h-5 w-24 bg-white/10 animate-pulse rounded-md" />)}
      </ul>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="space-y-3">
        {["Shop", "Cart", "Checkout"].map((label, i) => <li key={i} data-index={i}>
            <Link to="#" className="text-muted-foreground hover:text-primary transition-colors text-sm">
              {label}
            </Link>
          </li>)}
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors text-sm">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
function NewsletterForm() {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
  };
  return <form onSubmit={handleSubmit} className="flex w-full max-w-sm items-center space-x-2">
      <Input type="email" placeholder="Enter your email" className="bg-white/5 border-white/10 text-white placeholder:text-white/40 focus-visible:ring-primary focus-visible:border-primary" required />
      <Button type="submit" size="icon" className="shrink-0">
        <Send className="size-4" />
        <span className="sr-only">Subscribe</span>
      </Button>
    </form>;
}
export default function FooterHub() {
  const currentYear = new Date().getFullYear();
  const socialLinks = [{
    icon: Twitter,
    href: "#",
    label: "Twitter"
  }, {
    icon: Facebook,
    href: "#",
    label: "Facebook"
  }, {
    icon: Instagram,
    href: "#",
    label: "Instagram"
  }, {
    icon: Linkedin,
    href: "#",
    label: "LinkedIn"
  }];
  const legalLinks = [{
    label: "Privacy Policy",
    href: "#"
  }, {
    label: "Terms of Service",
    href: "#"
  }, {
    label: "Cookie Policy",
    href: "#"
  }];
  return <section id="footer-hub" className="dark bg-[hsl(220,20%,3%)] text-foreground border-t border-white/5 py-16 lg:py-24">
      <div className="container mx-auto px-6 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {}
          <div className="flex flex-col items-start space-y-6">
            <Link to="/" className="inline-block">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1630779/img/apexrig_tech_logo_light.png" alt="ApexRig Tech" className="h-7 w-auto object-contain" />
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed max-w-xs">
              ApexRig Tech is a modern online retail brand dedicated to offering a
              curated selection of high‑quality products across multiple categories.
            </p>
          </div>

          {}
          <div className="flex flex-col space-y-6">
            <h3 className="font-default text-lg font-semibold tracking-tight text-white">
              Quick Links
            </h3>
            <MenuProvider menu_id="23">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="flex flex-col space-y-6">
            <h3 className="font-default text-lg font-semibold tracking-tight text-white">
              Connect
            </h3>
            <div className="flex flex-wrap gap-4">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <Link key={i} data-index={i} to={social.href} aria-label={social.label} className="flex h-10 w-10 items-center justify-center rounded-full bg-white/5 border border-white/10 text-muted-foreground transition-all duration-300 hover:bg-primary/10 hover:border-primary/30 hover:text-primary hover:-translate-y-1 hover:shadow-[0_0_15px_rgba(0,255,255,0.3)]">
                    <Icon className="size-4" />
                  </Link>;
            })}
            </div>
          </div>

          {}
          <div className="flex flex-col space-y-6">
            <h3 className="font-default text-lg font-semibold tracking-tight text-white">
              Newsletter
            </h3>
            <p className="text-muted-foreground text-sm">
              Subscribe to get special offers, free giveaways, and
              once-in-a-lifetime deals.
            </p>
            <FormProvider form_id="newsletter_signup">
              <NewsletterForm />
            </FormProvider>
          </div>
        </div>

        {}
        <div className="mt-16 flex flex-col items-center justify-between gap-6 border-t border-white/10 pt-8 md:flex-row">
          <p className="text-muted-foreground text-sm text-center md:text-left">
            &copy; {currentYear} ApexRig Tech. All rights reserved.
          </p>
          <ul className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-sm text-muted-foreground">
            {legalLinks.map((link, i) => <React.Fragment key={i}>
                <li data-index={i}>
                  <Link to={link.href} className="hover:text-primary transition-colors">
                    {link.label}
                  </Link>
                </li>
                {i < legalLinks.length - 1 && <li aria-hidden="true" className="text-white/20">
                    &middot;
                  </li>}
              </React.Fragment>)}
          </ul>
        </div>
      </div>
    </section>;
}